class RegraExclusaoPorAnexo
  constructor: (args) ->
    {@id, @tabela, @fonteLegal, @estado, @observacoes,
    @naoCalculaDa, @naoCalculaAt, @vigenciaInicio, @vigenciaFim, @ncmsInclusao} = args

  getDescricao: () ->
    switch @tabela
      when 'isencao'
        'Isenção'
      when 'reducao_base_calculo'
        'Redução da Base de Cálculo'
      when 'substituicao_tributaria'
        'Substituição Tributária'


class RegraExclusaoPorAnexoService extends AbstractService

  configure: (configs, injector) ->
    configs.url = '/eficiencia-fiscal/regra-exclusao-por-anexo'

  getList: (args...) ->
    [query, callbackUsr, options] = @getListArgs(args)

    callback = (result) ->
      if result.data?.items?
        result.data.items = result.data.items.map((item) -> new RegraExclusaoPorAnexo(item))

      callbackUsr(result)

    @doRequest('GET', query, callback, options)

angular.module('eficienciaFiscalModule').service('regraExclusaoPorAnexoService', RegraExclusaoPorAnexoService)
